import React from 'react'
import { FormMicSiteArea } from './FormMicSiteArea';
import { Dialog } from 'primereact/dialog';


export const ModalMicSiteArea= (props) => {

    const {
        modal, modalTitle, toggle, method,
        validaciones,
        name, id_mic_site, sites,
        handleInputChange, loading,
        saveCreate, saveUpdate, saveDelete,

        closeDialog
    } = props;
    //////console.log(id_mic_site);
   // ////console.log(name);
    return (
        <Dialog 
            header={modalTitle}
            visible={modal}
            onHide={closeDialog}
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
        >
       
            {
                method === "create"
                    ? <FormMicSiteArea
                        button={"Crear sitio"}
                        {...{ toggle, loading, handleInputChange, sites, validaciones, closeDialog, methodAction: saveCreate, sites}}
                    />
                    : (method === "update")
                        ?
                        <FormMicSiteArea
                            button={"Actualizar sitio"}
                            {...{ toggle, loading, handleInputChange, id_mic_site, sites, validaciones, closeDialog, methodAction: saveUpdate, name, sites }} />
                        :
                        null
            }
        </Dialog>
    )
}
